// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ScheduleSettingDetailsFragmentDoc } from '../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ScheduleTabQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ScheduleTabQuery = { __typename?: 'Query', schedules: Array<{ __typename?: 'Schedule', id: string, stage: Types.Stage, status: Types.ScheduleStatus, reviewReminderDays: Array<Types.DayOfWeek>, scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined } | null | undefined }> };

export type PlanScheduleTabQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type PlanScheduleTabQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
    | { __typename?: 'Region', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
    | { __typename?: 'Market', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
    | { __typename?: 'Community', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
    | { __typename?: 'Subdivision', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
    | { __typename?: 'Lot', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
    | { __typename?: 'Structure', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
    | { __typename?: 'Unit', id: string, planSchedule?: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
        , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } | null | undefined }
  , globalPlanMilestones: { __typename?: 'GlobalPlanMilestonesPageResult', entities: Array<{ __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }> } };

export type SaveScheduleSettingsMutationVariables = Types.Exact<{
  input: Types.SaveScheduleSettingsInput;
}>;


export type SaveScheduleSettingsMutation = { __typename?: 'Mutation', saveScheduleSettings: { __typename?: 'SaveScheduleSettingsResult', scheduleSettings: Array<{ __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined }> } };

export type SavePlanScheduleSettingsMutationVariables = Types.Exact<{
  input: Types.SavePlanScheduleInput;
}>;


export type SavePlanScheduleSettingsMutation = { __typename?: 'Mutation', savePlanSchedule: { __typename?: 'SavePlanScheduleResult', planSchedule: { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
      , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> } } };

export type SaveScheduleRemindersMutationVariables = Types.Exact<{
  input: Types.SaveScheduleInput;
}>;


export type SaveScheduleRemindersMutation = { __typename?: 'Mutation', saveSchedule: { __typename?: 'SaveScheduleResult', schedule: { __typename?: 'Schedule', id: string, stage: Types.Stage, status: Types.ScheduleStatus, reviewReminderDays: Array<Types.DayOfWeek>, scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined } | null | undefined } } };

export type ScheduleTab_ScheduleFragment = { __typename?: 'Schedule', id: string, stage: Types.Stage, status: Types.ScheduleStatus, reviewReminderDays: Array<Types.DayOfWeek>, scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined } | null | undefined };

export type ScheduleTab_PlanScheduleFragment = { __typename?: 'PlanSchedule', id: string, targetStartDate: Types.Scalars['Date']['input'], targetEndDate: Types.Scalars['Date']['input'], currentBaselineDate: Types.Scalars['Date']['input'], targetCycleTimeInDays: number, targetConstructionRtsDate?: Types.Scalars['Date']['input'] | null | undefined, targetPreconRtsDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
  , planMilestoneTargets: Array<{ __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined }> };

export type ScheduleTab_PlanMilestoneTargetFragment = { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } }, communityTarget?: { __typename?: 'PlanMilestoneTarget', id: string, targetDaysFromRts: number } | null | undefined, planMilestone?: { __typename?: 'PlanMilestone', id: string, estEndDate?: Types.Scalars['Date']['input'] | null | undefined } | null | undefined };

export type ScheduleTab_GlobalPlanMilestoneFragment = { __typename?: 'GlobalPlanMilestone', id: string, name: string, type: { __typename?: 'GlobalPlanMilestoneTypeDetail', code: Types.GlobalPlanMilestoneType, name: string } };

export const ScheduleTab_ScheduleFragmentDoc = gql`
    fragment ScheduleTab_Schedule on Schedule {
  id
  stage
  status
  scheduleSetting {
    ...ScheduleSettingDetails
  }
  reviewReminderDays
}
    ${ScheduleSettingDetailsFragmentDoc}`;
export const ScheduleTab_PlanMilestoneTargetFragmentDoc = gql`
    fragment ScheduleTab_PlanMilestoneTarget on PlanMilestoneTarget {
  id
  targetDaysFromRts
  globalPlanMilestone {
    id
    name
    type {
      code
      name
    }
  }
  communityTarget {
    id
    targetDaysFromRts
  }
  planMilestone {
    id
    estEndDate
  }
}
    `;
export const ScheduleTab_PlanScheduleFragmentDoc = gql`
    fragment ScheduleTab_PlanSchedule on PlanSchedule {
  id
  parent {
    ... on Entity {
      id
    }
  }
  targetStartDate
  targetEndDate
  currentBaselineDate
  targetCycleTimeInDays
  targetConstructionRtsDate
  targetPreconRtsDate
  planMilestoneTargets {
    ...ScheduleTab_PlanMilestoneTarget
  }
}
    ${ScheduleTab_PlanMilestoneTargetFragmentDoc}`;
export const ScheduleTab_GlobalPlanMilestoneFragmentDoc = gql`
    fragment ScheduleTab_GlobalPlanMilestone on GlobalPlanMilestone {
  id
  name
  type {
    code
    name
  }
}
    `;
export const ScheduleTabDocument = gql`
    query ScheduleTab($projectId: ID!) {
  schedules(filter: {parent: [$projectId]}) {
    id
    ...ScheduleTab_Schedule
  }
}
    ${ScheduleTab_ScheduleFragmentDoc}`;

/**
 * __useScheduleTabQuery__
 *
 * To run a query within a React component, call `useScheduleTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTabQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useScheduleTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleTabQuery, ScheduleTabQueryVariables> & ({ variables: ScheduleTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTabQuery, ScheduleTabQueryVariables>(ScheduleTabDocument, options);
      }
export function useScheduleTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTabQuery, ScheduleTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTabQuery, ScheduleTabQueryVariables>(ScheduleTabDocument, options);
        }
// @ts-ignore
export function useScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTabQuery, ScheduleTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTabQuery, ScheduleTabQueryVariables>;
export function useScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTabQuery, ScheduleTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTabQuery | undefined, ScheduleTabQueryVariables>;
export function useScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTabQuery, ScheduleTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTabQuery, ScheduleTabQueryVariables>(ScheduleTabDocument, options);
        }
export type ScheduleTabQueryHookResult = ReturnType<typeof useScheduleTabQuery>;
export type ScheduleTabLazyQueryHookResult = ReturnType<typeof useScheduleTabLazyQuery>;
export type ScheduleTabSuspenseQueryHookResult = ReturnType<typeof useScheduleTabSuspenseQuery>;
export type ScheduleTabQueryResult = Apollo.QueryResult<ScheduleTabQuery, ScheduleTabQueryVariables>;
export const PlanScheduleTabDocument = gql`
    query PlanScheduleTab($projectId: ID!) {
  project(id: $projectId) {
    id
    planSchedule {
      ...ScheduleTab_PlanSchedule
    }
  }
  globalPlanMilestones(filter: {type: [PRECONSTRUCTION, CONSTRUCTION]}) {
    entities {
      ...ScheduleTab_GlobalPlanMilestone
    }
  }
}
    ${ScheduleTab_PlanScheduleFragmentDoc}
${ScheduleTab_GlobalPlanMilestoneFragmentDoc}`;

/**
 * __usePlanScheduleTabQuery__
 *
 * To run a query within a React component, call `usePlanScheduleTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanScheduleTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanScheduleTabQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePlanScheduleTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanScheduleTabQuery, PlanScheduleTabQueryVariables> & ({ variables: PlanScheduleTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>(PlanScheduleTabDocument, options);
      }
export function usePlanScheduleTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>(PlanScheduleTabDocument, options);
        }
// @ts-ignore
export function usePlanScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>;
export function usePlanScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanScheduleTabQuery | undefined, PlanScheduleTabQueryVariables>;
export function usePlanScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>(PlanScheduleTabDocument, options);
        }
export type PlanScheduleTabQueryHookResult = ReturnType<typeof usePlanScheduleTabQuery>;
export type PlanScheduleTabLazyQueryHookResult = ReturnType<typeof usePlanScheduleTabLazyQuery>;
export type PlanScheduleTabSuspenseQueryHookResult = ReturnType<typeof usePlanScheduleTabSuspenseQuery>;
export type PlanScheduleTabQueryResult = Apollo.QueryResult<PlanScheduleTabQuery, PlanScheduleTabQueryVariables>;
export const SaveScheduleSettingsDocument = gql`
    mutation SaveScheduleSettings($input: SaveScheduleSettingsInput!) {
  saveScheduleSettings(input: $input) {
    scheduleSettings {
      ...ScheduleSettingDetails
    }
  }
}
    ${ScheduleSettingDetailsFragmentDoc}`;
export type SaveScheduleSettingsMutationFn = Apollo.MutationFunction<SaveScheduleSettingsMutation, SaveScheduleSettingsMutationVariables>;

/**
 * __useSaveScheduleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveScheduleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduleSettingsMutation, { data, loading, error }] = useSaveScheduleSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduleSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveScheduleSettingsMutation, SaveScheduleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveScheduleSettingsMutation, SaveScheduleSettingsMutationVariables>(SaveScheduleSettingsDocument, options);
      }
export type SaveScheduleSettingsMutationHookResult = ReturnType<typeof useSaveScheduleSettingsMutation>;
export type SaveScheduleSettingsMutationResult = Apollo.MutationResult<SaveScheduleSettingsMutation>;
export type SaveScheduleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveScheduleSettingsMutation, SaveScheduleSettingsMutationVariables>;
export const SavePlanScheduleSettingsDocument = gql`
    mutation SavePlanScheduleSettings($input: SavePlanScheduleInput!) {
  savePlanSchedule(input: $input) {
    planSchedule {
      ...ScheduleTab_PlanSchedule
    }
  }
}
    ${ScheduleTab_PlanScheduleFragmentDoc}`;
export type SavePlanScheduleSettingsMutationFn = Apollo.MutationFunction<SavePlanScheduleSettingsMutation, SavePlanScheduleSettingsMutationVariables>;

/**
 * __useSavePlanScheduleSettingsMutation__
 *
 * To run a mutation, you first call `useSavePlanScheduleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanScheduleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanScheduleSettingsMutation, { data, loading, error }] = useSavePlanScheduleSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanScheduleSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanScheduleSettingsMutation, SavePlanScheduleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanScheduleSettingsMutation, SavePlanScheduleSettingsMutationVariables>(SavePlanScheduleSettingsDocument, options);
      }
export type SavePlanScheduleSettingsMutationHookResult = ReturnType<typeof useSavePlanScheduleSettingsMutation>;
export type SavePlanScheduleSettingsMutationResult = Apollo.MutationResult<SavePlanScheduleSettingsMutation>;
export type SavePlanScheduleSettingsMutationOptions = Apollo.BaseMutationOptions<SavePlanScheduleSettingsMutation, SavePlanScheduleSettingsMutationVariables>;
export const SaveScheduleRemindersDocument = gql`
    mutation SaveScheduleReminders($input: SaveScheduleInput!) {
  saveSchedule(input: $input) {
    schedule {
      ...ScheduleTab_Schedule
    }
  }
}
    ${ScheduleTab_ScheduleFragmentDoc}`;
export type SaveScheduleRemindersMutationFn = Apollo.MutationFunction<SaveScheduleRemindersMutation, SaveScheduleRemindersMutationVariables>;

/**
 * __useSaveScheduleRemindersMutation__
 *
 * To run a mutation, you first call `useSaveScheduleRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduleRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduleRemindersMutation, { data, loading, error }] = useSaveScheduleRemindersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduleRemindersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveScheduleRemindersMutation, SaveScheduleRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveScheduleRemindersMutation, SaveScheduleRemindersMutationVariables>(SaveScheduleRemindersDocument, options);
      }
export type SaveScheduleRemindersMutationHookResult = ReturnType<typeof useSaveScheduleRemindersMutation>;
export type SaveScheduleRemindersMutationResult = Apollo.MutationResult<SaveScheduleRemindersMutation>;
export type SaveScheduleRemindersMutationOptions = Apollo.BaseMutationOptions<SaveScheduleRemindersMutation, SaveScheduleRemindersMutationVariables>;